import React from 'react';
// import UserNav from './userNav';
// import UserConnect from './userConnect';

import { useParams, NavLink } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import { USER_INIT } from '../constants/globals.js';
import { reinitUserPW } from '../actions/actions-types.js';

const UserViewReinit = (props) => {

    const dispatch = useDispatch();
    const [userFiche, setUserFiche] = useState(USER_INIT);
    const [userSave, setUserSave] = useState({ saved: false });
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    function checkEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUserFiche(oldUser => { return { ...userFiche, [name]: value, uMsg: "" }; });
        event.preventDefault();
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let errMsg = "";
        if (!checkEmail(userFiche.uMail)) {
            errMsg = "L'adresse mail n'est pas valide !";
            setUserFiche(oldUser => { return { ...userFiche, msgInfo: errMsg }; });
        } else {
            fetch(`${URL_COURTJUS_BACK}/userverifexist/${userFiche.uMail}`, {
                method: 'GET',
                headers: headers,
            })
                .then(response => response.json())
                .then(res => {
                    if (res != null) {
                        if (res[0].nb > 0) {
                            if (!errMsg) {
                                // Modification d'un utilisateur
                                dispatch(reinitUserPW({ userFiche }))
                                errMsg = "Un mail va vous être envoyé avec votre nouveau mot de passe (Verifiez dans les messages indesirables)"
                                setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                                setUserSave(oldUser => { return { ...userSave, saved: true }; });
                            }
                        } else {
                            errMsg = "Adresse mail inconnue !"
                            setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                        }
                    } else {
                        errMsg = "Il n'y a aucun compte à cette adresse !"
                        setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                    }
                });
        };
    };



    return (
        <main className="container">
            <div className="main-down"></div>
            {/* {userMenu===true && <UserNav />} */}
            {/* {userMenu===true && <UserConnect />} */}
            <section className="section-prods section-prods-form">
                <form method="POST" id="formContact" encType="multipart/form-data" onSubmit={handleSubmit}>
                    <article className="section-prods-fiche form-fiche">
                        <fieldset>
                            <legend>Mon adresse mail</legend>
                            <p><input type="email" className="input-dbl" name="uMail" id="uMail" value={userFiche.uMail} onChange={handleChange} required /></p>
                        </fieldset>

                    </article>
                    <article className="section-prods-infos form-fiche">
                        <fieldset><p>
                            {!userSave.saved &&
                                <button id="fiche-sav" className='btn btn-primary'>Reinitialiser mon mot de passe !</button>
                            }
                            {userSave.saved &&
                                <NavLink to={`/`} className="btn btn-secondary" title="Retour accueil">Retour</NavLink>
                            }
                        </p></fieldset>
                    </article>
                    <section className="nav-admin"><p className="section-prods-err">{userFiche.uMsg}</p></section>
                </form>
            </section>
            <div className="main-down"></div>
        </main>

    )
}

export default UserViewReinit;